module.exports = __webpack_public_path__ + "img/teamImg23.70433fea.png";